export enum GenerateEmailTokenType {
  VERIFICATION_CODE = 'VERIFICATION_CODE',
  EMAIL_VALIDATION = 'VALIDAR_EMAIL',
}
